<template>
    <b-container fluid>
        <b-row class="justify-content-start">
            <b-col v-for="course in courses" :key="course.id" cols="12" md="4" lg="3">
                <div class="course-card" @click="selectCourse(course.id)">
                    <b-img :src="course.image" fluid class="course-image" :alt="$t('academy.course_image')"></b-img>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: "CoursesGrid",
    props: {
        courses: {
            type: Array,
            required: true,
        },
        context: {
            type: String,
            default: "academy" // "academy" para AcademyView, "groups" para GroupsView
        }
    },
    methods: {
        selectCourse(courseId) {
            try {
                if (this.context === "academy") {
                    // Redirigir a la vista del curso
                    this.$router.push({
                        name: 'course-view',
                        params: { courseId }
                    });
                } else if (this.context === "groups") {
                    // Emitir un evento para manejar la selección del curso en GroupsView
                    this.$emit('course-selected', courseId);
                }
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') {
                    console.error('Error de navegación:', error);
                }
            }
        }
    }
};
</script>

<style scoped>
.course-card {
    border-radius: 25px;
    overflow: hidden;
    transition: transform 0.3s ease-in-out;
    cursor: pointer;
}

.course-card:hover {
    transform: scale(1.05);
}

.course-image {
    width: 100%;
    border-radius: 25px;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
}
</style>
